import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import {API_TRIBUTUM_URL} from "@constants";
import {getTokenFromTributum} from "@services";
import {comLoading} from '@stores';
import type { CabecalhosRequisicao, ClienteHttp, OpcoesResposta, ParametrosRequisicao } from '../types';

export const tributumInstance = axios.create({
    baseURL: API_TRIBUTUM_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    maxBodyLength: Infinity,
});

tributumInstance.interceptors.request.use(async config => {
    const token = await getTokenFromTributum();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
}, error => {
    return Promise.reject(error);
});


export function useRequestTributum(): ClienteHttp {
    function get<T>(url: string, params?: ParametrosRequisicao, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(tributumInstance.get<T>(url, {params, headers, ...opcoes}));
    }

    function post<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(tributumInstance.post<T>(url, body, {headers, ...opcoes}));
    }

    function put<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        return comLoading(tributumInstance.put<T>(url, body, {headers, ...opcoes}));
    }

    function delet<T, D = unknown>(url: string, body?: D, headers?: CabecalhosRequisicao, opcoes?: OpcoesResposta): Promise<AxiosResponse<T>> {
        const config: AxiosRequestConfig<D> = {data: body, headers, ...opcoes};
        return comLoading(tributumInstance.delete<T>(url, config));
    }

    return {
        get,
        post,
        put,
        delet,
    };
}
